import React from 'react';

interface IconProps {
	className?: string;
	style?: React.CSSProperties;
}


const MenuIcon = (props: IconProps) => {
	return (
		<svg
			fill="none"
			height="20"
			viewBox="0 0 6 20"
			width="6"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.375 17.25C5.375 17.8467 5.13795 18.419 4.71599 18.841C4.29403 19.2629 3.72174 19.5 3.125 19.5C2.52826 19.5 1.95597 19.2629 1.53401 18.841C1.11205 18.419 0.875 17.8467 0.875 17.25C0.875 16.6533 1.11205 16.081 1.53401 15.659C1.95597 15.2371 2.52826 15 3.125 15C3.72174 15 4.29403 15.2371 4.71599 15.659C5.13795 16.081 5.375 16.6533 5.375 17.25ZM5.375 9.75C5.375 10.3467 5.13795 10.919 4.71599 11.341C4.29403 11.7629 3.72174 12 3.125 12C2.52826 12 1.95597 11.7629 1.53401 11.341C1.11205 10.919 0.875 10.3467 0.875 9.75C0.875 9.15326 1.11205 8.58097 1.53401 8.15901C1.95597 7.73705 2.52826 7.5 3.125 7.5C3.72174 7.5 4.29403 7.73705 4.71599 8.15901C5.13795 8.58097 5.375 9.15326 5.375 9.75ZM5.375 2.25C5.375 2.84674 5.13795 3.41903 4.71599 3.84099C4.29403 4.26295 3.72174 4.5 3.125 4.5C2.52826 4.5 1.95597 4.26295 1.53401 3.84099C1.11205 3.41903 0.875 2.84674 0.875 2.25C0.875 1.65326 1.11205 1.08097 1.53401 0.65901C1.95597 0.237053 2.52826 0 3.125 0C3.72174 0 4.29403 0.237053 4.71599 0.65901C5.13795 1.08097 5.375 1.65326 5.375 2.25Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default MenuIcon;
